import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

import { START_TOUCH, TOUCH } from '@confluence/navdex/entry-points/NavdexPointType.ts';

export const fireCustomHomepageClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef: any) => (): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'customHomepage',
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					isInMore: false,
					navVersion: '4',
					navdexPointType: START_TOUCH,
				},
			},
		}).fire();
	};

export const fireHomeClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef: any) => (): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'home',
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					isInMore: false,
					navVersion: '4',
					navdexPointType: START_TOUCH,
				},
			},
		}).fire();
	};

export const fireRecentsClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef: any) =>
	(isExpanded: boolean, shortcut = false, hidden = false): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'recent',
				attributes: {
					shortcut,
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					isInMore: hidden,
					navVersion: '4',
					navdexPointType: START_TOUCH,
					status: isExpanded ? 'expanded' : 'collapsed',
				},
			},
		}).fire();
	};

export const fireStarredClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef: any) =>
	(isExpanded: boolean, shortcut = false, hidden = false): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'starred',
				attributes: {
					shortcut,
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					isInMore: hidden,
					navVersion: '4',
					navdexPointType: START_TOUCH,
					status: isExpanded ? 'expanded' : 'collapsed',
				},
			},
		}).fire();
	};

export const fireSpacesClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef: any) =>
	(isExpanded: boolean): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'spaces',
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					isInMore: false,
					navVersion: '4',
					navdexPointType: START_TOUCH,
					status: isExpanded ? 'expanded' : 'collapsed',
				},
			},
		}).fire();
	};

export const fireDraftsClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef: any) => (): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'drafts',
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					isInMore: false,
					navVersion: '4',
					navdexPointType: START_TOUCH,
				},
			},
		}).fire();
	};

export const fireTeamsClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef: any) => (): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'teams',
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					isInMore: false,
					navVersion: '4',
					navdexPointType: START_TOUCH,
					gasEnabled: true,
				},
			},
		}).fire();
	};

export const fireAppsClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef: any) =>
	(isExpanded: boolean): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'apps',
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					isInMore: false,
					navVersion: '4',
					navdexPointType: START_TOUCH,
					status: isExpanded ? 'expanded' : 'collapsed',
				},
			},
		}).fire();
	};

export const fireTasksClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef: any) => (): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'tasks',
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					isInMore: false,
					navVersion: '4',
					navdexPointType: START_TOUCH,
				},
			},
		}).fire();
	};

export const fireTemplatesClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef: any) => (): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'templates',
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					isInMore: false,
					navVersion: '4',
					navdexPointType: TOUCH,
				},
			},
		}).fire();
	};

export const fireCustomizeSidebarClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef: any) => (): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'customiseSidebar',
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					isInMore: false,
					navVersion: '4',
					navdexPointType: TOUCH,
				},
			},
		}).fire();
	};

export const fireMoreMenuClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef: any) =>
	(menuId: any): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: menuId,
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					isInMore: true,
					navVersion: '4',
					navdexPointType: START_TOUCH,
				},
			},
		}).fire();
	};
